module.exports = __webpack_public_path__ + "static/media/RPV_220.1091e8e1.png";